import { TableWrapper } from './styles';

interface IProps {
    list: any[]
}

const PreselectsByCenter = (props: IProps) => {
    return (
        <div style={{ height: 400, overflowY: 'scroll' }}>
            <TableWrapper className='table table-condensed'>
                <thead>
                    <tr>
                        <th style={{ width: '25%' }}>Center</th>
                        <th style={{ width: '25%' }}>Preselects Outstanding</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {props.list.map((item, index) =>
                        <tr key={index}>
                            <td>{item.centerAlias}</td>
                            <td>{item.count}</td>
                            <td><a href={'/center/' + item.centerId + '/recipients/donor-pre-select'} target='_blank'>link to center's preselect page</a></td>
                        </tr>
                    )}
                </tbody>
            </TableWrapper>
        </div>
    );
}

export default PreselectsByCenter;